import { Dispatch, SetStateAction } from "react"
export type Response<T> = {
    isSuccess: boolean;
    message: string;
    result: T;
    resultCode: number;
}
export enum Gender {
    female = 0,
    male = 1,
    other = 2
}
export type User = {
    merchantId: number | null;
    mobileNumber: number;
    firstName: string;
    lastName: string;
    gender: Gender;
    email: string;
    forcedChangePassword: boolean;
    isActive: boolean;
    isVerified: boolean;
    refreshToken: string;
    refreshTokenExpireTime: string;
    fullName: string;
    avatar?: string;
    nationalCode?: number;
}
export type Menu = {
    menuId: number;
    parentId: number | null;
    showInMenu: boolean;
    orderPriority: number;
    path: string | null;
    name: string;
    icon: string | null;
    isDefault: boolean;
    roleId: number
    roleName: string;
    hasChild: boolean;
    havePath: boolean;
    childMenus: null | Menu[]
}
export type TooltipItem = {
    value?: string | number | null;
    name?: string;
    color?: string;
    colorForValue?: boolean;
    divider?: boolean;
    redGreenMode?: boolean;
    formatValue?: boolean;
    dir?: "rtl" | "ltr"
    prefix?: string;
    suffix?: string;
}
export type PagedData<T> = {
    items: T[];
    totalPages: number;
    totalCount: number;
    hasPrevious: boolean;
    hasNext: boolean;
    pageNumber: number;
    pageSize: number;
}
export enum StateType {
    added = 0,
    inProcessing = 5,
    success = 10,
    failed = 15,
    finish = 20,
}
export type PagedListUpdater<T> = Dispatch<SetStateAction<PagedData<T> | null>>;
export type ListUpdater<T> = Dispatch<SetStateAction<T[] | null>>;
export type Updater<T> = Dispatch<SetStateAction<PagedData<T> | T[] | null>>;
export type Theme = "light" | "dark";
export type Dictionary = { [key: string]: string }
export type EnumItem = {
    Name : string;
    Type : string;
    Value : number;
    DisplayName : string;
    DataType : string;
    Description : string;
}
export * from "./reports";
export * from "./tracker";